import React from 'react';
import PropTypes from 'prop-types';

const ErrorIcon = ({ width, height }) => (
  <svg width={width} height={height} viewBox="0 0 20 20" version="1.1">
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Component/Status-Notification/Danger" transform="translate(-17.000000, -17.000000)" fill="#C02F1D" fillRule="nonzero">
        <g id="Danger">
          <g id="error.svg" transform="translate(17.000000, 17.000000)">
            <path d="M10,0 C4.48,0 0,4.475 0,10 C0,15.525 4.48,20 10,20 C15.52,20 20,15.525 20,10 C20,4.475 15.52,0 10,0 Z M11,15 L9,15 L9,13 L11,13 L11,15 Z M11,11 L9,11 L9,5 L11,5 L11,11 Z" id="Shape" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

ErrorIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};

ErrorIcon.defaultProps = {
  width: '20px',
  height: '20px',
};

export default ErrorIcon;
